import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
const organizationHistorySearchSchema = z.object({
  baseDate: z.string().optional()
});

/** @note 未実装のため詳細ページにリダイレクト */
export const Route = createFileRoute('/_staff/organization/$id/_layout/history/')({
  validateSearch: zodValidator(organizationHistorySearchSchema),
  beforeLoad: ({
    params,
    search
  }: {
    params: {
      id: string;
    };
    search: {
      baseDate?: string;
    };
  }) => {
    // baseDateがある場合はクエリパラメータとして引き継ぐ
    const searchParams = search.baseDate ? {
      baseDate: search.baseDate
    } : {};
    throw redirect({
      to: '/organization/$id',
      params: {
        id: params.id
      },
      search: searchParams
    });
  }
});